import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { captureAttribution } from 'utils/attribution'

/**
 * Keeps the ref / ch / utm tags of a tagged visit (utils/attribution.ts) on
 * every page the router shows, so a visitor who lands anywhere in the app and
 * signs up later is counted against the link that brought them. The first
 * tagged visit wins; a visit without tags keeps nothing.
 */
export function useAttributionCapture(): void {
  const { pathname, search } = useLocation()
  useEffect(() => {
    captureAttribution({ pathname, search })
  }, [pathname, search])
}
